export const MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export const DAY_LABELS = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];
// python weekday: Mon=0..Sun=6 -> index maps directly to DAY_LABELS

export const WEEKDAY_OPTIONS = [
  { value: 0, label: "Senin" },
  { value: 1, label: "Selasa" },
  { value: 2, label: "Rabu" },
  { value: 3, label: "Kamis" },
  { value: 4, label: "Jumat" },
  { value: 5, label: "Sabtu" },
  { value: 6, label: "Minggu" },
];

export const formatRupiah = (n) => {
  const num = Number(n || 0);
  return "Rp" + num.toLocaleString("id-ID");
};

export const formatTanggal = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
};

export const formatTanggalShort = (iso) => {
  const [y, m, day] = iso.split("-");
  return `${day}/${m}/${y}`;
};

export const formatTanggalMini = (iso) => {
  const [, m, day] = iso.split("-");
  return `${day}/${m}`;
};

export const weekdayName = (iso) => {
  const d = new Date(iso + "T00:00:00");
  const py = (d.getDay() + 6) % 7; // JS Sun=0 -> py Mon=0
  return DAY_LABELS[py];
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" });
};
